/**
 * @name ConfirmDialog
 * @author Gabriel M. Guimarães | gabrielmg7
 * @description Diálogo de confirmação reutilizável para ações que requerem confirmação do usuário
 * @param {ConfirmDialogProps} props - Props do componente
 * @returns {JSX.Element} Diálogo de confirmação
 * @package src/components/common/dialogs/ConfirmDialog.tsx
 */

import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import React from 'react';

type ButtonColor = 'inherit' | 'primary' | 'secondary' | 'success' | 'error' | 'info' | 'warning';

interface ConfirmDialogProps {
     open: boolean;
     title: string;
     content: string;
     onConfirm: () => void;
     onCancel: () => void;
     confirmButtonText?: string;
     cancelButtonText?: string;
     confirmButtonColor?: ButtonColor;
     cancelButtonColor?: ButtonColor;
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({ open, title, content, onConfirm, onCancel, confirmButtonText = 'Confirmar', cancelButtonText = 'Cancelar', confirmButtonColor = 'primary', cancelButtonColor = 'inherit' }) => {
     return (
          <Dialog
               open={open}
               onClose={onCancel}
               aria-labelledby='confirm-dialog-title'
               aria-describedby='confirm-dialog-description'
          >
               <DialogTitle id='confirm-dialog-title'>{title}</DialogTitle>
               <DialogContent>
                    <DialogContentText id='confirm-dialog-description'>{content}</DialogContentText>
               </DialogContent>
               <DialogActions>
                    <Button
                         onClick={onCancel}
                         color={cancelButtonColor}
                    >
                         {cancelButtonText}
                    </Button>
                    <Button
                         onClick={onConfirm}
                         color={confirmButtonColor}
                         variant='contained'
                         autoFocus
                    >
                         {confirmButtonText}
                    </Button>
               </DialogActions>
          </Dialog>
     );
};

export default ConfirmDialog;
